export default __webpack_public_path__ + "static/media/iconmonstr-twitter-3.ca6dab93.svg";